export default "__VITE_PUBLIC_ASSET__6886a279__"